import type { ComponentType, ReactNode, ReactNodeArray } from 'react';

import { window } from '../../globals';
import Redirect from '../generic/Redirect';
import type { RouterProps } from '../../types';

type AuthProps = {
  children: ReactNode | ReactNodeArray;
  location: RouterProps['location'];
};

export type AuthPage = 'login' | 'register';

/**
 * Root-level for authentication views.
 */
const Auth = ({ children }: AuthProps) => (
  <main className="fossa-auth">
    {children}
  </main>
);

//  Higher-order component which renders a redirect if the user is already logged in.
const withRedirectOnLoggedIn = (AuthComponent: ComponentType<any>) => function (props: AuthProps = {} as AuthProps) {
  //  If there is a user but they don't have an org, we still render the auth component (the user needs to create/select an org).
  const isLoggedIn: boolean = !!window.user?.organization;
  return isLoggedIn
    ? <Redirect to="/" replace />
    : <AuthComponent {...props} />;
};

export default withRedirectOnLoggedIn(Auth);
